export enum TimeChoiceIdx {
  THIRTY_M = 0,
  FORTY_FIVE_M = 1,
  ONE_H = 2,
  NINETY_M = 3,
  TWO_H = 4,
  THREE_H = 5,
  FOUR_H = 6,
  FIVE_H = 7,
  SIX_H = 8,
  INFINITY = 9,
}
